module.exports = __webpack_public_path__ + "img/mp6.001030ba.png";